module.exports = __webpack_public_path__ + "img/society.4e5b6ea2.webp";